import { computed } from 'vue';

export default class StudyCardTrackingInformation {
	public dataLabel = computed((): string => {
		return this.enhanced ? 'premium' : 'basic';
	});

	constructor(private id: string, private title: string, private enhanced: boolean) {}
}
